// Eaglesway Group - Premium Corporate Data

export const companyLogos = {
  group: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/n8ui3ypm_EAGLESWAY%20GROUP%20LOGO.jpeg',
  trading: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/jv5ap0gi_EAGLESWAY%20GENERAL%20TRADING%20FZ%20LLC%20LOGO%20.jpeg',
  marketing: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/6jeaq4ui_EAG%20MARKETING%20LOGO.jpeg',
  uk: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/6iqo121k_EAGLESWAY%20UK%20LTD%20LOGO.jpeg',
  usa: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/wcwo5jst_EAGLESWAY%20USA%20LOGO.jpeg',
};

export const companyDivisions = [
  {
    id: 1,
    country: 'UAE',
    division: 'Trading Division',
    company: 'Eaglesway General Trading FZ-LLC',
    shortName: 'Eaglesway Trading',
    title: 'Global Sourcing & Procurement',
    tagline: 'Your Global Trading Partner',
    logo: companyLogos.trading,
    description: 'A UAE-based global trading company specializing in sourcing and supply across multiple industries.',
    location: 'Ras Al Khaimah, UAE',
    fullAddress: `Compass Building,
Al Shohada Road,
Al Hamra Industrial Zone – FZ,
Ras Al Khaimah,
United Arab Emirates`,
    phone: '+971 52 571 2721',
    email: 'contact@eagles-way.com',
    salesEmail: 'sales.eaglesway@gmail.com',
    services: [
      'Global sourcing',
      'Supplier coordination',
      'Procurement',
      'Trade support',
      'General trading',
      'Import & export',
      'Agricultural commodities',
      'Industrial machinery & parts',
      'Oil & gas products',
      'Construction materials',
      'Electronics sourcing',
    ],
    activities: [
      'General trading',
      'Import & export',
      'Agricultural commodities',
      'Industrial machinery & parts',
      'Oil & gas products',
      'Construction materials',
      'Electronics sourcing'
    ]
  },
  {
    id: 2,
    country: 'UAE',
    division: 'Marketing Division',
    company: 'Eaglesway Marketing LLC',
    shortName: 'Eaglesway Marketing',
    title: 'Marketing, Branding & Business Development',
    tagline: 'Elevate Your Brand Globally',
    logo: companyLogos.marketing,
    description: 'Focused on marketing, business development, and client growth.',
    location: 'Dubai, UAE',
    fullAddress: `Al Muteena,
Abu Baker Al Siddique Road,
Al Ghurair Office Block B, Mezzanine Floor,
Dubai,
United Arab Emirates`,
    phone: '+971 52 571 2721',
    email: 'contact@eagles-way.com',
    salesEmail: 'sales.eaglesway@gmail.com',
    services: [
      'Marketing strategy',
      'Client engagement',
      'Business expansion support',
      'Marketing management',
      'Brand support',
      'Business development',
      'Client acquisition',
      'Trade promotion'
    ],
    activities: [
      'Marketing management',
      'Brand support',
      'Business development',
      'Client acquisition',
      'Trade promotion'
    ]
  },
  {
    id: 3,
    country: 'UK',
    division: 'UK Division',
    company: 'Eaglesway UK Ltd',
    shortName: 'Eaglesway UK',
    title: 'Wholesale Supply & Distribution',
    tagline: 'European Market Excellence',
    logo: companyLogos.uk,
    description: 'Supporting international trade and market access.',
    location: 'London, United Kingdom',
    fullAddress: `71–75 Shelton Street,
Covent Garden,
London WC2H 9JQ,
United Kingdom`,
    phone: '+44 203 967 8364',
    email: 'contact@eagles-way.com',
    salesEmail: 'sales.eaglesway@gmail.com',
    services: [
      'UK market support',
      'Trade coordination',
      'Trade facilitation',
      'Supply chain coordination',
      'Client representation',
      'Market access'
    ],
    activities: [
      'Trade facilitation',
      'Supply chain coordination',
      'Client representation',
      'Market access'
    ]
  },
  {
    id: 4,
    country: 'USA',
    division: 'USA Division',
    company: 'Eaglesway LLC',
    shortName: 'Eaglesway USA',
    title: 'Import-Export & Logistics Solutions',
    tagline: 'Americas Trade Gateway',
    logo: companyLogos.usa,
    description: 'Expanding business presence in North America.',
    location: 'Delaware, United States',
    fullAddress: `8 The Green, Suite B,
Dover, DE 19901,
United States`,
    phone: '+1 812 812 6742',
    email: 'contact@eagles-way.com',
    salesEmail: 'sales.eaglesway@gmail.com',
    services: [
      'US market support',
      'Sourcing and supply links',
      'Market expansion',
      'Trade coordination',
      'Product sourcing',
      'Commercial networking'
    ],
    activities: [
      'Market expansion',
      'Trade coordination',
      'Product sourcing',
      'Commercial networking'
    ]
  },
];

export const featuredProducts = [
  {
    id: 1,
    category: 'Oil & Gas Products',
    icon: '⚡',
    image: 'https://images.unsplash.com/photo-1698757803598-e6318a9a22c4',
    description: 'Premium oil and gas products, equipment, and industrial solutions for energy sector operations.',
    featured: true,
  },
  {
    id: 2,
    category: 'Electronics & Diodes',
    icon: '💻',
    image: 'https://images.unsplash.com/photo-1744368191937-8fe5fde474a8',
    description: 'High-quality electronic components, diodes, and data center equipment for technology infrastructure.',
    featured: true,
  },
  {
    id: 3,
    category: 'Premium Coffee',
    icon: '☕',
    image: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e',
    description: 'Specialty-grade coffee beans sourced from premium plantations worldwide for discerning markets.',
    featured: true,
  },
  {
    id: 4,
    category: 'Industrial Machinery',
    icon: '⚙️',
    image: 'https://images.unsplash.com/photo-1701448149957-b96dbd1926ff',
    description: 'Advanced industrial machinery, equipment, and precision parts for manufacturing operations.',
    featured: false,
  },
  {
    id: 5,
    category: 'Construction Materials',
    icon: '🏗️',
    image: 'https://images.unsplash.com/photo-1709244596182-a7c6542be59c',
    description: 'Quality steel, concrete, and construction materials for large-scale infrastructure projects.',
    featured: false,
  },
  {
    id: 6,
    category: 'Agricultural Commodities',
    icon: '🌾',
    image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449',
    description: 'Premium sesame, moringa, grains, and agricultural products for international distribution.',
    featured: false,
  },
  {
    id: 7,
    category: 'Bitumen & Asphalt',
    icon: '🛣️',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e',
    description: 'High-grade bitumen and asphalt products for road construction and infrastructure development.',
    featured: false,
  },
  {
    id: 8,
    category: 'Medical Equipment',
    icon: '🏥',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    description: 'Hospital and clinical equipment supply for healthcare facilities and medical institutions.',
    featured: false,
  },
  {
    id: 9,
    category: 'Gold & Precious Metals',
    icon: '💰',
    image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d',
    description: 'Precious metals sourcing and supply through trusted global networks and verified suppliers.',
    featured: false,
  },
];

export const services = [
  {
    id: 1,
    title: 'Global Sourcing & Procurement',
    icon: '🌍',
    description: 'Premium product sourcing from trusted global manufacturers with competitive pricing and reliable supply chains.',
  },
  {
    id: 2,
    title: 'Marketing & Brand Development',
    icon: '📢',
    description: 'Strategic marketing services, brand positioning, and public relations for international business growth.',
  },
  {
    id: 3,
    title: 'Wholesale Distribution',
    icon: '📦',
    description: 'Efficient bulk supply and distribution services to wholesalers, retailers, and distributors across markets.',
  },
  {
    id: 4,
    title: 'Import-Export Solutions',
    icon: '🚢',
    description: 'Comprehensive logistics, customs clearance, and international shipping for seamless global trade.',
  },
  {
    id: 5,
    title: 'Oil & Gas Supply',
    icon: '⚡',
    description: 'Specialized supply of oil and gas products, equipment, and solutions for energy sector operations.',
  },
  {
    id: 6,
    title: 'Electronics & Technology',
    icon: '💻',
    description: 'Advanced electronics, diodes, and data center equipment supply for technology infrastructure needs.',
  },
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Global Network',
    description: 'Strategic presence across UAE, UK, and USA enables seamless international operations.',
  },
  {
    id: 2,
    title: 'Proven Reliability',
    description: 'Trusted by businesses worldwide for consistent quality and professional service.',
  },
  {
    id: 3,
    title: 'Industry Expertise',
    description: 'Decades of combined experience across multiple sectors and global markets.',
  },
  {
    id: 4,
    title: 'End-to-End Solutions',
    description: 'Complete supply chain management from sourcing to final delivery.',
  },
];

export const teamMembers = [
  {
    id: 1,
    name: 'MELEYONE.B',
    title: 'CEO / Founder',
    division: 'Eaglesway Group',
    image: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/lo0la7dr_MELEYONE%20CID%20ID%20PHOTO.jpeg',
  },
  {
    id: 2,
    name: 'AMEYOU BIRHANU',
    title: 'Trade & Logistics Coordinator',
    division: 'Operations',
    image: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/0jv41cfz_WhatsApp%20Image%202025-12-10%20at%2014.55.22_51275525.jpg',
  },
  {
    id: 3,
    name: 'MERON DEREJE',
    title: 'Business Development Officer',
    division: 'Business Development',
    image: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/3v6vpyfo_MERON%20DEREJE.jpg',
  },
  {
    id: 4,
    name: 'SANA BEN AMEUR',
    title: 'Assistant Manager',
    division: 'Management',
    image: 'https://customer-assets.emergentagent.com/job_premium-sourcing-7/artifacts/qixiqfzy_WhatsApp%20Image%202025-12-25%20at%202.59.57%20PM.jpeg',
  },
];

export const globalLocations = [
  {
    id: 1,
    city: 'Ras Al Khaimah',
    country: 'UAE',
    type: 'Head Office – Trading',
    flag: '🇦🇪',
    address: 'Al Shohada Road, AL Hamra Industrial Zone-FZ',
    phone: '+971 52 571 2721',
  },
  {
    id: 2,
    city: 'Dubai',
    country: 'UAE',
    type: 'Marketing Office',
    flag: '🇦🇪',
    address: 'Dubai, United Arab Emirates',
    phone: '+971 52 571 2721',
  },
  {
    id: 3,
    city: 'London',
    country: 'UK',
    type: 'Wholesale & Distribution',
    flag: '🇬🇧',
    address: '71-75 Shelton Street, Covent Garden, London, WC2H 9JQ',
    phone: '+44 203 967 8364',
  },
  {
    id: 4,
    city: 'Dover',
    country: 'USA',
    type: 'Import-Export & Logistics',
    flag: '🇺🇸',
    address: '8 The Green, Suite Dover, DE 19901',
    phone: '+1 302 481 4885',
  },
];

export const contactInfo = {
  company: 'Eaglesway Group',
  phone: '+971 52 571 2721',
  email: 'contact@eagles-way.com',
  website: 'www.eagles-way.com',
  headquarters: 'Ras Al Khaimah, UAE',
  whatsapp: '+971525712721',
};

export const socialLinks = {
  facebook: 'https://facebook.com/eagleswaygroup',
  linkedin: 'https://linkedin.com/company/eaglesway-group',
  twitter: 'https://twitter.com/eagleswaygroup',
  instagram: 'https://www.instagram.com/eaglesway_group',
};
